<template>
  <div
    class="w-64 rounded-lg border border-container-border dark:border-container-border-dark bg-box-container-bg dark:bg-box-container-bg-dark shadow-dropdown p-1.5"
  >
    <div class="flex items-center gap-2.5 px-2.5 py-2">
      <Avatar :name="userName" />
      <div class="min-w-0">
        <p class="text-sm font-medium text-heading dark:text-heading-dark truncate">
          {{ userName }}
        </p>
        <p class="text-xs text-content dark:text-content-dark truncate">
          {{ userOrg }} · {{ role }}
        </p>
      </div>
    </div>

    <div
      class="my-1 border-t border-container-border dark:border-container-border-dark"
    ></div>

    <MenuButton
      :label="$t('userSettingsMenu.account')"
      :icon="MdiCogOutline"
      @click="handleAccountClick"
    />

    <MenuButton
      :label="$t('tour.restart')"
      :icon="MdiMapMarkerPath"
      @click="emit('tour')"
    />

    <!-- Kept apart from the other items: the menu opens above its trigger,
         so this is the item nearest to it. Logging out asks first (see
         Sidebar.vue). -->
    <div
      class="my-1 border-t border-container-border dark:border-container-border-dark"
    ></div>

    <MenuButton
      :label="$t('userSettingsMenu.logout')"
      :icon="MdiLogout"
      @click="handleLogoutClick"
    />
  </div>
</template>

<script setup lang="ts">
import MenuButton from "./MenuButton.vue";
import Avatar from "./Avatar.vue";
import MdiCogOutline from "~icons/mdi/cog-outline";
import MdiLogout from "~icons/mdi/logout";
import MdiMapMarkerPath from "~icons/mdi/map-marker-path";

interface UserSettingsProps {
  userName: string;
  userOrg: string;
  role: string;
}

type UserSettingsEmits = {
  account: [];
  logout: [];
  tour: [];
};

withDefaults(defineProps<UserSettingsProps>(), {
  userName: "",
  userOrg: "",
  role: "",
});

const emit = defineEmits<UserSettingsEmits>();

const handleAccountClick = (): void => {
  emit("account");
};

const handleLogoutClick = (): void => {
  emit("logout");
};
</script>
